module.exports = __webpack_public_path__ + "img/icon_card09.b65fb222.png";